import React from "react";
import ReusableDataTable from "../../hooks/ReusableDataTable";
import { Button, Checkbox, Label, Modal, TextInput } from "flowbite-react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import '../../style/model.css';
import { FaPen } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import { HiOutlineExclamationCircle } from "react-icons/hi";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import axios from "axios";
import useInputValidation from "../../hooks/useInputValidation";
import { useSidebar } from "../../context/SidebarOpenContext";
import CustomSelect from "../../hooks/CustomSelect";

function Staff() {
    const navigate = useNavigate();
    const [AddModal, setAddModal] = useState(false);
    const [EditModal, setEditModal] = useState(false);
    const [DeleteModal, setDeleteModal] = useState(false);
    const [Input, setInput] = useState({});
    const [EditInput, setEditInput] = useState({});
    const [Staff, setStaff] = useState({});
    const { errors, handleChange, resetErrors } = useInputValidation();
    const { isSidebarOpen, toggleSidebar } = useSidebar();
    const [selectedRole, setselectedRole] = useState('');


    useEffect(() => {
        fetchStaff();
    }, []);


    const onChangeValue = (e) => {
        handleChange(e);
        setInput({ ...Input, [e.target.name]: e.target.value });
    }

    const onEditChangeValue = (e) => {
        handleChange(e);
        setEditInput({ ...EditInput, [e.target.name]: e.target.value });
    }

    const fetchStaff = async () => {
        try {
            const response = await axios.get("master/users");
            const StaffData = response.data;
            setStaff(StaffData);
        } catch (error) {
            console.error("Error fetching Staff data:", error);
        }
    };

    const addStaff = async (event) => {
        event.preventDefault();

        try {
            const res = await axios.post(`master/users`, {
                staff_name: Input.sname,
                phone_no: Input.phoneno,
                username: Input.username,
                password: Input.password,
                role: selectedRole
            });

            // Success responses (2xx)
            if (res.data.success === 1) {
                Swal.fire({
                    icon: "success",
                    text: "Staff Created",
                    timer: 2000,
                    showConfirmButton: false,
                });
                setAddModal(false);
                fetchStaff();
                setselectedRole(null);
            } else if (res.data.success === 2) {
                Swal.fire({
                    icon: "error",
                    text: res.data.msg,
                    timer: 2000,
                    showConfirmButton: false,
                });
            } else {
                Swal.fire({
                    icon: "error",
                    text: "Unexpected response from server.",
                    timer: 2000,
                    showConfirmButton: false,
                });
            }

        } catch (error) {
            // Handle 400 error or any other non-2xx error
            Swal.fire({
                icon: "error",
                text: error.response?.data?.msg || "Server Problem. Please Try Again...",
                timer: 2000,
                showConfirmButton: false,
            });
        }
    };


    const UpdateStaff = async (event) => {
        event.preventDefault();

        try {
            axios
                .put(`master/users/${EditInput.id}`, {
                    staff_name: EditInput.sname,
                    phone_no: EditInput.phoneno,
                    username: EditInput.username,
                    password: EditInput.password,
                    role: selectedRole
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Staff  Details Updated",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        setEditModal(false);
                        fetchStaff();
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }

    };

    const deletStaff = async () => {
        try {
            axios.delete(`master/users/${EditInput.id}`).then((res) => {
                if (res.data.success === 1) {
                    Swal.fire({
                        icon: "success",
                        text: "Staff  deleted",
                        type: "success",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                    fetchStaff();
                    setDeleteModal(false);
                } else {
                    Swal.fire({
                        icon: "error",
                        text: "Server Problem. Please Try Again...",
                        type: "error",
                        timer: 2000,
                        showConfirmButton: false,
                    });
                }
                return;
            });
        } catch (error) {
            throw error;
        }
    };


    const data = Array.isArray(Staff)
        ? Staff.map((Staff) => ({
            id: Staff.staff_id,
            sname: Staff.staff_name,
            phoneno: Staff.phone_no,
            username: Staff.username,
            role: Staff.role,
            option: (<div style={{ display: "flex" }}>
                <FaPen className="text-amber-400 text-xl" onClick={() => {
                    setEditModal(true); setEditInput({
                        id: Staff.staff_id,
                        sname: Staff.staff_name,
                        phoneno: Staff.phone_no,
                        username: Staff.username,
                        password: Staff.password,
                    });
                    setselectedRole(Staff.role)
                }} />
                <MdDeleteForever className="ml-2 text-red-500 text-2xl" onClick={() => { setDeleteModal(true); setEditInput({ id: Staff.staff_id }) }} />
            </div>)
        }))
        : [];

    const columns = [
        { name: "S.No", selector: (row, index) => index + 1, sortable: true },
        { name: "Staff Name", selector: (row) => row.sname, sortable: true },
        { name: "Phone No", selector: (row) => row.phoneno, sortable: true },
        { name: "Role", selector: (row) => row.role, sortable: true },
        { name: "Username", selector: (row) => row.username, sortable: true },
        { name: "Option", selector: (row) => row.option },
    ];

    const Role_options = [
        {
            value: "Cutting_Staff",
            label: "Cutting_Staff",
        },
        {
            value: "Sewing_Staff",
            label: "Sewing_Staff",
        },
        {
            value: "Finishing_Staff",
            label: "Finishing_Staff",
        },
        {
            value: "FM",
            label: "FM",
        },
        {
            value: "Accountant",
            label: "Accountant",
        },
    ]

    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >

            <div className="p-4 rounded-lg dark:border-gray-700  mt-14">
                <div className="p-4 rounded-lg shadow bg-white">
                    <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" onClick={() => setAddModal(true)} >Add Staff</Button>
                    <ReusableDataTable
                        title="Staff List"
                        columns={columns}
                        data={data}
                    />
                </div>
            </div>

            <Modal show={AddModal} size="md" onClose={() => { setAddModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Add Staff</h3>
                        <form onSubmit={addStaff}>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.sname && "failure"} value="Staff Name" />
                                </div>
                                <TextInput
                                    id="sname"
                                    name="sname"
                                    placeholder=""
                                    type="text"
                                    required
                                    color={errors.sname && "failure"}
                                    helperText={
                                        errors.sname && (
                                            <>
                                                <span className="font-medium"></span> {errors.sname}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[A-Za-z\s]*$"

                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Phone Number" color={errors.phoneno && "failure"} />
                                </div>
                                <TextInput
                                    id="phoneno"
                                    color={errors.phoneno && "failure"}
                                    name="phoneno"
                                    type="text"
                                    required
                                    maxLength={10}
                                    helperText={
                                        errors.phoneno && (
                                            <>
                                                <span className="font-medium"></span> {errors.phoneno}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                    pattern="^[6-9]\d{9}$" />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block font-medium">
                                    <Label htmlFor="buyer" value="Role" />
                                </div>
                                <CustomSelect
                                    value={selectedRole}
                                    onChange={(selected) => {
                                        setselectedRole(selected);
                                    }}
                                    options={Role_options}
                                    placeholder="Select an option"
                                    id="buyer-select"
                                    name="buyerSelect"
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="username" value="Username" color={errors.username && "failure"} />
                                </div>
                                <TextInput
                                    id="username"
                                    color={errors.username && "failure"}
                                    name="username"
                                    type="text"
                                    required
                                    maxLength={10}
                                    helperText={
                                        errors.username && (
                                            <>
                                                <span className="font-medium"></span> {errors.username}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue} />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="password" value="Password" color={errors.password && "failure"} />
                                </div>
                                <TextInput
                                    id="password"
                                    color={errors.password && "failure"}
                                    name="password"
                                    type="text"
                                    required
                                    maxLength={10}
                                    helperText={
                                        errors.password && (
                                            <>
                                                <span className="font-medium"></span> {errors.password}
                                            </>
                                        )
                                    }
                                    onChange={onChangeValue}
                                />
                            </div>

                            <div className="pt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setAddModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={EditModal} size="md" onClose={() => { setEditModal(false); resetErrors(); }} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="space-y-6">
                        <h3 className="text-xl font-medium text-gray-900 dark:text-white">Update Staff</h3>
                        <form onSubmit={UpdateStaff}>
                            <div>
                                <div className="mt-2 mb-2 block">
                                    <Label htmlFor="email" color={errors.sname && "failure"} value="Staff Name" />
                                </div>
                                <TextInput
                                    id="sname"
                                    name="sname"
                                    placeholder=""
                                    type="text"
                                    required
                                    onChange={onEditChangeValue}
                                    value={EditInput.sname}
                                    color={errors.sname && "failure"}
                                    helperText={
                                        errors.sname && (
                                            <>
                                                <span className="font-medium"></span> {errors.sname}
                                            </>
                                        )
                                    }
                                    pattern="^[A-Za-z\s0-9]*$"

                                />
                            </div>

                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="phoneno" value="Phone Number" color={errors.phoneno && "failure"} />
                                </div>
                                <TextInput
                                    id="phoneno"
                                    color={errors.phoneno && "failure"}
                                    name="phoneno"
                                    type="text"
                                    required
                                    onChange={onEditChangeValue}
                                    value={EditInput.phoneno}
                                    maxLength={10}
                                    helperText={
                                        errors.phoneno && (
                                            <>
                                                <span className="font-medium"></span> {errors.phoneno}
                                            </>
                                        )
                                    }
                                    pattern="^\d{10}$" />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="buyer" value="Role" />
                                </div>
                                <CustomSelect
                                    value={selectedRole}
                                    onChange={(selected) => {
                                        setselectedRole(selected);
                                    }}
                                    options={Role_options}
                                    placeholder="Select an option"
                                    id="buyer-select"
                                    name="buyerSelect"
                                />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="username" value="Username" color={errors.username && "failure"} />
                                </div>
                                <TextInput
                                    id="username"
                                    color={errors.username && "failure"}
                                    name="username"
                                    type="text"
                                    required
                                    maxLength={10}
                                    helperText={
                                        errors.username && (
                                            <>
                                                <span className="font-medium"></span> {errors.username}
                                            </>
                                        )
                                    }
                                    onChange={onEditChangeValue}
                                    value={EditInput.username} />
                            </div>
                            <div>
                                <div className="pt-2 mb-2 block">
                                    <Label htmlFor="password" value="Reset Password" color={errors.password && "failure"} />
                                </div>
                                <TextInput
                                    id="password"
                                    color={errors.password && "failure"}
                                    name="password"
                                    type="text"
                                    maxLength={10}
                                    helperText={
                                        errors.password && (
                                            <>
                                                <span className="font-medium"></span> {errors.password}
                                            </>
                                        )
                                    }
                                    onChange={onEditChangeValue}
                                />
                            </div>


                            <div className="mt-2 w-full flex justify-center">
                                <Button className="bg-icon-color  text-sidebar-color drop-shadow-md  font-bold" type="submit">Submit</Button>
                                <Button className="ml-2" color="gray" onClick={() => { setEditModal(false); resetErrors(); }}>
                                    Cancel
                                </Button>
                            </div>
                        </form>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={DeleteModal} size="md" onClose={() => setDeleteModal(false)} popup>
                <Modal.Header />
                <Modal.Body>
                    <div className="text-center">
                        <HiOutlineExclamationCircle className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200" />
                        <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                            Are you sure you want to delete this Staff?
                        </h3>
                        <div className="flex justify-center gap-4">
                            <Button color="failure" onClick={() => deletStaff()}>
                                {"Yes"}
                            </Button>
                            <Button color="gray" onClick={() => setDeleteModal(false)}>
                                No
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

        </div>


    );
}

export default Staff;
